export enum BuildEnv {
  spinner = 'SPINNER',
  crossTable = 'CROSSTABLE',
  marketplace = 'MARKETPLACE',
}
